import i18next from 'i18next';

export const isJapaneseLocale = () => {
  const { language } = i18next;
  return language === 'ja';
};

export const isKoreanLocale = () => {
  const { language } = i18next;
  return language === 'ko';
};
